import firebase from "firebase/app"
import "firebase/firestore"
import "firebase/auth"
// import "firebase/storage"

const firebaseConfig = {
  apiKey: "AIzaSyBE9o3GH2aoHd0-mNBRmZ_8oAXT2uGBCk4",
  authDomain: "schoolboard-demo.firebaseapp.com",
  projectId: "schoolboard-demo",
  storageBucket: "schoolboard-demo.appspot.com",
  messagingSenderId: "746547453437",
  appId: "1:746547453437:web:0cb2b1ec61bb4807688d94",
}

// init firebase
firebase.initializeApp(firebaseConfig)

// init services
const projectFirestore = firebase.firestore()
const projectAuth = firebase.auth()
// const projectStorage = firebase.storage()

// timestamp
const timestamp = firebase.firestore.FieldValue.serverTimestamp

export { projectFirestore, projectAuth, timestamp }
